import { computed } from "vue";
import { useDisplay } from "vuetify";

/** App shell breakpoints — align with sw-responsive.css */
export const SHELL_BREAKPOINTS = {
  mobileMax: 767,
  tabletMin: 768,
  tabletMax: 1279,
  desktopMin: 1280,
};

/**
 * Shared layout mode for LandingPage sidebar / header.
 * - desktop (1280+): full sidebar in flow, optional icon rail via chevron
 * - tablet (768–1279): docked icon rail + hamburger opens full overlay drawer
 * - mobile (<768): hidden sidebar, hamburger opens overlay drawer only
 */
export function useAppShellLayout() {
  const { width } = useDisplay();

  const layoutMode = computed(() => {
    const w = width.value;
    if (w <= SHELL_BREAKPOINTS.mobileMax) return "mobile";
    if (w <= SHELL_BREAKPOINTS.tabletMax) return "tablet";
    return "desktop";
  });

  const isDesktop = computed(() => layoutMode.value === "desktop");
  const isTablet = computed(() => layoutMode.value === "tablet");
  const isMobile = computed(() => layoutMode.value === "mobile");
  const isCompactShell = computed(() => !isDesktop.value);

  const showMenuButton = computed(() => isCompactShell.value);

  return {
    width,
    layoutMode,
    isDesktop,
    isTablet,
    isMobile,
    isCompactShell,
    showMenuButton,
  };
}
